import { useLocale } from 'next-intl'

export function useLocalizedField() {
  const locale = useLocale()

  const getLocalizedField = (item: any, fieldName: string, fallback = '') => {
    // For French, check base field first, then _fr suffix
    if (locale === 'fr') {
      return item[fieldName] || item[`${fieldName}_fr`] || item[`${fieldName}_en`] || fallback
    }
    
    const localeMap: Record<string, string> = {
      'en': '_en',
      'ar': '_ar',
      'ru': '_ru',
      'zh': '_zh',
      'ja': '_ja',
      'ko': '_ko'
    }
    
    const suffix = localeMap[locale] || '_en'
    return item[`${fieldName}${suffix}`] || item[`${fieldName}_en`] || item[fieldName] || fallback
  }

  return { getLocalizedField }
}